/**
 * <hero-video> Web Component
 * Wraps a background <video> with a mute/unmute toggle button.
 * The video autoplays muted; the button lets the user toggle sound.
 */
if (!customElements.get('hero-video')) {
  class HeroVideo extends HTMLElement {
    constructor() {
      super();
      this._onClick = this._handleToggle.bind(this);
    }

    connectedCallback() {
      this.video = this.querySelector('video');
      this.muteBtn = this.querySelector('.hero-banner__mute-btn');

      if (!this.video || !this.muteBtn) return;

      this.video.muted = true;
      this.muteBtn.setAttribute('data-muted', 'true');

      this.muteBtn.addEventListener('click', this._onClick);

      this.video.play().catch(function () {
        /* Autoplay blocked — poster image shows instead */
      });
    }

    disconnectedCallback() {
      if (this.muteBtn) {
        this.muteBtn.removeEventListener('click', this._onClick);
      }
    }

    _handleToggle() {
      if (!this.video) return;

      var isMuted = this.video.muted;
      this.video.muted = !isMuted;
      this.muteBtn.setAttribute('data-muted', String(!isMuted));

      this.muteBtn.setAttribute(
        'aria-label',
        this.video.muted ? this.muteBtn.dataset.labelUnmute : this.muteBtn.dataset.labelMute
      );
    }
  }

  customElements.define('hero-video', HeroVideo);
}
